module.exports = __webpack_public_path__ + "static/media/no-image-icon.695dffd6.PNG";


//////////////////
// WEBPACK FOOTER
// ./src/Images/no-image-icon.PNG
// module id = 75
// module chunks = 0